export const QUERY_KEY = {
    GET_USERBY_ID: 'get_userby_id',
    CREATE_REFERRAL: 'create_referral',
    GET_ALL_USERS: 'get_all_users',
    GET_ALL_COLLABORATORS: 'get_all_collaborators',
    GET_COMMISSION_REPORT: 'get_commission_report',
    COLLABORATOR_ORDERS: 'get_orders_by_collaboratorId',
    GET_COLLABORATOR_REFERRALS: 'get_collaborator_referrals',
    GET_COLLABORATOR_DASHBOARD_DATA: 'collaborator_dashboard_data',
    GET_ALL_GIGS_FOR_CURRENT_PROVIDER: 'get_all_gigs_current_provider',
    GET_GIG_BASED_ON_STATUS: 'get_gigs_based_on_status',
    APPROVED_GIGS: 'approved_gigs',
    PENDING_GIGS:'pending_gigs',
    REJECTED_GIGS: 'rejected_gigs',
    PAUSED_GIGS: 'paused_gigs',
    GET_GIG_BY_ID: 'gigbyID',
    GET_TOKEN: 'get_token',
    GET_COMPLAINTS: 'get_complaints',
    GET_JOBS_COUNT: 'get_jobs_count',
    GET_COMPLAINTS_COUNT: 'get_complaints_count',
    GET_WIZER_COMMISSION: 'get_wizer_count',
    GET_ALL_IMAGES: 'get_all_images'
}

export const GIG_STATUS_CODES = {
    PENDING: 0,
    APPROVED: 1,
    REJECTED: 2

}